import React from 'react';

import NoteLinkedEmbeddingTab from 'notebook/embeddings/NoteLinkedEmbeddingTab';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

interface PreviewButtonProps {
  contentId: string;
  fileId: string;
  name: string;
  getEmbedding: () => React.ReactNode;
}

export default function PreviewButton({
  contentId,
  fileId,
  name,
  getEmbedding,
}: PreviewButtonProps): JSX.Element {
  return (
    <Tooltip placement={FloatingPlacement.TOP} text="Open in Preview">
      <Button
        onClick={() => {
          NoteLinkedEmbeddingTab.open(fileId, contentId, name, getEmbedding());
        }}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon="expand-right-full"
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
